import { startCountdown, formatMmSs } from "../utils/countdown";

// Олон удаа буруу оролдсоны улмаас түр түгжигдсэн үед (429 + `seconds`) тоолуур ажиллуулна.
export default {
  data() {
    return {
      lockSeconds: 0,
      stopLockTimer: null,
    };
  },
  computed: {
    isLocked() {
      return this.lockSeconds > 0;
    },
    lockCountdown() {
      return formatMmSs(this.lockSeconds);
    },
  },
  methods: {
    startLockCountdown(seconds) {
      this.stopLockCountdown();
      this.stopLockTimer = startCountdown(seconds, (left) => {
        this.lockSeconds = left;
      });
    },
    stopLockCountdown() {
      if (this.stopLockTimer) this.stopLockTimer();
      this.stopLockTimer = null;
      this.lockSeconds = 0;
    },
  },
  beforeDestroy() {
    this.stopLockCountdown();
  },
};
